import { type AccountData, type AccountListInput, type AccountListSuccess } from '@terros/common'
import { accountsInfiniteKey } from '../keys'
import { useTantalimInfiniteQuery, type GetInfiniteHookResponse } from '../infiniteQuery'
import { useDecoratedAccountListInput } from './util'
import { useAccountCache } from './cache'

export function useInfiniteAccounts(_input: AccountListInput = {}): GetInfiniteHookResponse<AccountData> {
  const input = useDecoratedAccountListInput({ ..._input, size: _input.size ?? 1000 })
  const cache = useAccountCache()
  return useTantalimInfiniteQuery<AccountListInput, AccountListSuccess, AccountData>({
    url: '/account/list',
    queryKey: accountsInfiniteKey(input),
    input,
    selectRecords: (page) => page.accounts,
    buildNextInput: (input, sortTimestamp) => ({
      ...input,
      searchInput: input.searchInput && {
        ...input.searchInput,
        sortTimestamp,
      },
    }),
    onPageFetched: (result) => {
      result.accounts.forEach(cache.addItem)
    },
  })
}
